var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndopenLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 540 540",
    style: {
      enableBackground: "new 0 0 540 540"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#171717;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.8,368.5c-24.6,0-44.5,20-44.4,44.6s20,44.5,44.6,44.4c24.6,0,44.4-20,44.4-44.5 C314.4,388.4,294.4,368.5,269.8,368.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394.5,135.9c-36,0-67.8,13.5-100,40.1c-17.2-67.2-58.6-104.9-122.3-104.9C99.2,71.1,45,119.3,45,189.9 c0,48.6,25.7,89.9,55.9,112.5l2.2-2.2c-11.8-14-22.2-42.1-22.2-73.5c0-65.3,45.1-108.6,109.8-108.6c45.6,0,76.4,21.5,95.5,65 L121.8,328.7c-23.9,21.2-47.6,40.5-71,57.8v82.4c34.7-36.2,67.2-66.5,97.3-92.7l155.2-135c10.8,70.2,46.8,104.5,100.9,104.5 c53.5,0,90.8-32.7,90.8-99.3C495,180.7,457,135.9,394.5,135.9z M407.1,308.7c-50,0-82-25.6-95.8-74.4l12.5-10.9 c35.6-30.9,63.4-46.5,94.4-46.5c38.6,0,63.4,24.4,63.4,66C481.7,287.9,451.4,308.7,407.1,308.7L407.1,308.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndopenLogo);
export default __webpack_public_path__ + "static/media/andopen_logo.e96de041b6ac3f9fb008f649cff61023.svg";
export { ForwardRef as ReactComponent };